export const TEXTS_PMP = {
  es_ES: new Map([
    ['pmo_pagadas', 'Ratio Operaciones Pagadas (días)'],
    ['pmo_pendientes', 'Ratio Operaciones Pendientes (días)'],
    ['dias', 'PMP (días)'],
    ['imp_pagado', 'Importe Pagos Realizados'],
    ['imp_pendiente', 'Importe Pagos Pendientes'],
    ['cod_organico', 'Código Orgánico'],
    ['desc_cod_organico', 'Servicio'],
    ['tiempo_importe_pendiente', 'Impacto PMP'],
    ['reset', 'Restablecer'],
    ['download', 'Descargar'],
    ['periodo_medio_pagadas', 'Periodo Medio Operaciones Pagadas (días)'],
    [
      'periodo_medio_pendientes',
      'Periodo Medio Operaciones Pendientes de pago (días)',
    ],
    [
      'periodo_medio_pago_proveedores',
      'Periodo Medio de Pago a Proveedores (días)',
    ],
    ['importe_total_pendiente', 'Importe Total Pendiente de Pago (€)'],
    ['importe_total_pagado', 'Importe Total Pagado (€)'],
    ['pmp_ayuntamiento', 'PMP AYUNTAMIENTO'],
    ['pmp_entidades', 'PMP ENTIDADES'],
    ['pmp_dias', 'Días'],
  ]),
  ca_ES: new Map([
    ['pmo_pagadas', 'Periode mitjà Operacions Pagades'],
    ['pmo_pendientes', 'Periode mitjà Operacions Pendents de Pagament'],
    ['dias', 'Periode mitjà de Pagaments a Proveïdors (dies)'],
    ['imp_pagado', 'Import Total Pagat (€)'],
    ['imp_pendiente', 'Import Total Pendent de Pagament (€)'],
    ['cod_organico', 'Codi Orgànic'],
    ['desc_cod_organico', 'Servei'],
    ['tiempo_importe_pendiente', 'Impacte PMP'],
    ['reset', 'Restablir'],
    ['download', 'Desar'],
    ['periodo_medio_pagadas', 'Període Mitjà Operacions Pagades (dies)'],
    [
      'periodo_medio_pendientes',
      'Període Mitjà Operacions Pendents de Pagament (dies)',
    ],
    [
      'periodo_medio_pago_proveedores',
      'Període Mitjà de Pagament a Proveïdors (dies)',
    ],
    ['importe_total_pendiente', 'Import Total Pendent de Pagament'],
    ['importe_total_pagado', 'Import Total Pagat'],
    ['pmp_ayuntamiento', 'PMP Ajuntament'],
    ['pmp_entidades', 'PMP Entitats'],
    ['pmp_dias', 'Díes'],
  ]),
};
